import { Injectable } from '@angular/core';

declare var exponea: any;

type ServiceTypes = 'abc' | 'ccd' | 'd2d';
type UpsellTouchPoint = 'old_funnel_noslot_availability_';

export type BannerTouchpoint =
  | 'homepage_footer' | 'oldfunnel_payment' | 'newfunnel_payment'
  | 'flight_page' | 'confirmation_page' | 'mmb' | `${UpsellTouchPoint}${ServiceTypes}`;

export type BannerCategory = 'email' | 'sms_whatsapp';

export interface BannerOptInParams {
  category: BannerCategory;
  touchpoint: BannerTouchpoint;
  email?: string;
  phone?: string;
}

const NA = 'N/A';

@Injectable({ providedIn: 'root' })
export class ExponeaBannerService {

  trackOptIn(params: BannerOptInParams): void {
    if (typeof exponea === 'undefined' || !exponea) { return; }

    exponea.track('banner', {
      action: 'subscribe',
      banner_id: NA,
      banner_name: NA,
      banner_type: 'optin',
      interaction: NA,
      variant_id: NA,
      variant_name: NA,
      link: NA,
      email: params.email || NA,
      'variant origin': NA,
      path: NA,
      action_id: NA,
      campaign_id: NA,
      category: params.category,
      phone: params.phone || NA,
      touchpoint: params.touchpoint,
    });
  }
}
